<template>
  <data-chip
    :text="statusText(status)"
    :color="statusColor(status)"
    :iconLeft="statusIcon(status)"
    :small="small"
  >
  </data-chip>
</template>

<script>
import DataChip from "@/components/_systemwide/DataChip.vue";
export default {
  name: "performance-target-status-chip",
  components: {
    DataChip,
  },
  props: {
    status: {
      type: String,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    statusText(statusId) {
      switch (statusId) {
        case "green":
          return "Erfüllt";
        case "yellow":
          return "Teilweise erfüllt";
        case "red":
          return "Nicht erfüllt";
        case "met":
          return "Erfüllt";
        case "notMet":
          return "Nicht erfüllt";
        case "metByIndividualRuling":
          return "Erfüllt (EA)";
        case "notMetByIndividualRuling":
          return "Nicht erfüllt (EA)";
        case "suspended":
          return "Ausgesetzt";
        case "notApplicable":
          return "Nicht anwendbar";
        case "unknown":
          return "Unbekannt";
        default:
          return "Fehler";
      }
    },
    statusIcon(statusId) {
      switch (statusId) {
        case "green":
        case "met":
        case "metByIndividualRuling":
          return "check";
        case "yellow":
          return "alert";
        case "red":
        case "notMet":
          return "close";
        default:
          return "help";
      }
    },
    statusColor(statusId) {
      switch (statusId) {
        case "green":
        case "met":
        case "metByIndividualRuling":
          return "green";
        case "yellow":
          return "orange";
        case "red":
        case "notMet":
          return "red";
        case "fullySuspended":
        case "temporarilySuspended":
        case "notStarted":
        case "notApplicable":
        case "unknown":
          return "grey";
        case "individualRuling":
          return "purple";
        default:
          return "grey";
      }
    },
  },
};
</script>
